import React, { useEffect } from "react";
import { Banner, Reviews } from "../../components";
// import Comparison from "./Comparison";
import ProjectsSection from "./ProjectsSection";
import PageMeta from "../../seo/PageMeta";

const Projects = () => {
  useEffect(() => {
    window.scroll({ behavior: "smooth", top: 0 });
  }, []);
  return (
    <div className="flex flex-col items-center w-full">
      <PageMeta
        title="Projects"
        description="See recent commercial and residential cleaning projects completed by Clear Choice Cleaning Services across Melbourne, Australia."
        path="/projects"
        image="/assets/images/banners/gallery.webp"
      />
      <Banner page="gallery" heading="Projects" />

      <ProjectsSection />
      {/* <Comparison /> */}
      <Reviews />
    </div>
  );
};

export default Projects;
